import type { ICandidateChallenge, ICandidateObjective, IChallenge, IObjective } from "@bbj-types/challenge";
import type { ObjectId, Override } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosChallenges } from "./axios";

export type TGetCandidateChallenges = Override<
  ICandidateChallenge,
  {
    challenge: Pick<IChallenge, "_id" | "name" | "icon">;
    objectives: Override<ICandidateObjective, { objective: IObjective }>[];
  }
>[];

export const useGetCandidateChallenges = () => {
  const [state, execute, cancel] = axiosChallenges<TGetCandidateChallenges, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidate: ObjectId) => {
      return execute({
        url: `/candidate/${candidate}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
